$(document).ready(function () {
    var isMobile = false; //initiate as false, device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        isMobile = true;
    }

    if (isMobile) {
        $('#skipnavlink').attr('aria-hidden', 'true');
    } else {
        $('#skipnavlink').attr('aria-hidden', 'false');
    }

    const tabbableSelector = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const getTabbable = function (elem) {
        return $(elem).find(tabbableSelector).addBack(tabbableSelector);
    };

    const slickADA = function (sliderElem) {
      $(sliderElem).on("init initAfterDestroy", function (e, slick) {
          if (slick.$prevArrow) slick.$prevArrow[0].removeAttribute('aria-disabled');
          if (slick.$nextArrow) slick.$nextArrow[0].removeAttribute('aria-disabled');

        let tabLocked = false;

        slick.$slides.each(function (index, slide) {

          if (!slide.id) {
            slide.id = `slick-slide${index}`;
          }

          $(slide).on("keydown", function (e) {
            const tabbable = getTabbable(slide);
            const activeSlides = slick.$slides.filter(".slick-active");

            if (tabLocked && e.key === "Tab") {
              e.preventDefault();
              return false;
            }

            if (e.key === "Tab" && !e.shiftKey) {
              if (
                Math.ceil((slick.currentSlide + 1) / slick.options.slidesToShow) <
                  Math.ceil(slick.slideCount / slick.options.slidesToShow) &&
                activeSlides.index(slide) === activeSlides.length - 1 &&
                document.activeElement === tabbable[tabbable.length - 1]
              ) {
                tabLocked = true;
                slick.$slider.one("afterChangeAndADA", function () {
                  const targets = getTabbable($(slide).next());
                  if (targets.length) {
                    targets[0].focus();
                  }
                  tabLocked = false;
                });
                slick.slickNext();
                e.preventDefault();
              }
            } else if (e.key === "Tab" && e.shiftKey) {
              if (
                slick.currentSlide + 1 > slick.options.slidesToShow &&
                activeSlides.index(slide) === 0 &&
                document.activeElement === tabbable[0]
              ) {
                tabLocked = true;
                slick.$slider.one("afterChangeAndADA", function () {
                  const targets = getTabbable($(slide).prev());
                  if (targets.length) {
                    targets[targets.length - 1].focus();
                  }
                  tabLocked = false;
                });
                slick.slickPrev();
                e.preventDefault();
              }
            }
          });
        });
      });
    };

    $('.carousel').each(function() {
        slickADA(this);
        $(this).slick({
            accessibility: true,
            slidesToShow: $(this).data('show'),
            slidesToScroll: $(this).data('show'),
            dots: true,
            dotsPerSlide: true,
            dotsTabToActive: false,
            appendDots: $('.static-dots'),
            ADAFocusSlideFromArrow: true, // focus slide when arrow is clicked
            ADAFocusSlideFromDot: true, // focus slide when dot is clicked
            arrows: true,
            infinite: false,
            focusOnChange: false,
            responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '20px',
                    initialSlide: 0,
                    arrows: false
                }
            }],
            customPaging: function(slick, index) {
              return `<button type="button" role="tab" data-index="${index}" id="slick-slide-control${index}" aria-controls="slick-slide${index}">`
                    +`Go to slide ${index + 1} of ${slick.slideCount}`
                    +`</button>`;
            },
        });

        // ** aria-labelledby management:
        var $slickDots = $(this).parent().find('.slick-dots');
        $slickDots.attr('aria-labelledby', 'carouselheading-1');
        $slickDots.find('button').each((index, dot) => {
          dot.removeAttribute('tabindex');
        });

        $(this).find('.slick-track').attr('role', 'list');

        // ** aria-selected management:
        // setup for aria-selected based on presence 'slick-active' class
        function updateAriaSelected($carousel) {
          var $dots = $carousel.parent().find('.slick-dots li button');

          $dots.each((index, dot) => {
            dot.removeAttribute('tabindex');
          });
  
          $carousel.find('.slick-slide').each(function(index, slide) {
            var isSelected = $(this).hasClass('slick-active');
            slide.setAttribute('role', 'listitem');
            $dots.eq(index).attr('aria-selected', isSelected);
          });
        }
    
        // func updating aria-selected attributes w/delay
        $(this).on('afterChange', function() {
            setTimeout(function() {
                updateAriaSelected($(this));
            }.bind(this), 50); 
        });
    
        // setup for aria-selected
        updateAriaSelected($(this));
    });

    AOS.init();
});

